import { CarteiraMacroRegiao } from '@/models/carteiraMacroRegiao'
import { CarteiraMacroRegiaoAPI } from '@/api/carteiraMacroRegiao.api'
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface'

const carteiraMacroRegiaoApi = new CarteiraMacroRegiaoAPI()

const login = (identidade: string, dataNascimento: string, recaptcha: string): AxiosObservable<CarteiraMacroRegiao[]> => {
  return carteiraMacroRegiaoApi.login(identidade, dataNascimento, recaptcha);
}

export default { login }
